interface MidListCTAProps {
  breakdownName: string;
  breakdownTypeSlug: string;
  ctaLinkTextTemplate: string;
  preLinkText: string;
  utmCampaignPrefix: string;
}

export const MidListCTA = ({
  breakdownName,
  breakdownTypeSlug,
  ctaLinkTextTemplate,
  preLinkText,
  utmCampaignPrefix,
}: MidListCTAProps) => {
  const ctaLinkText = ctaLinkTextTemplate.replace("{}", breakdownName);

  return (
    <div className="my-6 flex items-center justify-center gap-2 rounded-lg border border-brand-100 bg-brand-50 py-4 text-center sm:col-span-2 lg:col-span-3">
      <p className="text-text-primary">{preLinkText}</p>
      <a
        href={`/discovery?utm_campaign=${utmCampaignPrefix}&utm_source=${breakdownTypeSlug}`}
        className="text-base text-brand-700 underline transition-colors hover:text-brand-800 hover:no-underline"
      >
        {ctaLinkText}
      </a>
    </div>
  );
};
